  var select = document.getElementById("ContactForm-marca");
  var marcas = ["MAXUS","MAHINDRA","CHERY","SSANGYONG","HYUNDAI","KIA","FOTON","MG","GREATWALL","CHANGAN","JMC","JAC"];
  select.innerHTML = '<option selected disabled></option>'
  for(var i = 0; i < marcas.length; i++) {
      var opt = marcas[i];
      var el = document.createElement("option");
      el.textContent = opt;
      el.value = opt;
      select.appendChild(el);
  }

    function cargarModelos() {
    document.getElementById("ContactForm-label-marca").style.display = "none";
    
    var listaModelos = {
      HYUNDAI : ["Accent","Creta","Elantra","Eon","Galloper","Getz","H-1","H-100","H-350","H-350 Solati","HD35","I-10","I-20","I-30","Matrix","Mighty","Porter","Santa Fe","Santamo","Sonata","Starex","Staria","Terracan","Trajet","Tucson","Veracruz","Veloster", "Verna"],
      KIA : ["Asia","Avella","Besta","Carens","Carnival","Cerato","Frontier","K-2400","Morning","Optima","Pop","Pregio","Pride","Rio","Scoupe","Seltos","Sephia","Soluto","Sorento","Soul","Spectra","Sportage"],
      SSANGYONG : ["Actyon","Korando","Musso","Rexton","Stavic","Tivoli","XLV"],
      MG : ["MG3","MG350","MG GT","MG 5","MG 6","ZS","ZX"],
      CHANGAN : ["Alsvin","Hunter","MD 201"],
      FOTON : ["Midi Truck 1.3"],
      MAHINDRA : ["KUV-100","Pick Up","Quanto","Scorpio","XUV 500"],
      MAXUS : ["Delivery 9", "C35","G10","T60","T90","V80","V90"],
      JMC : ["Vigus Works", "Vigus Plus"],
      CHERY : ["Fulwin","IQ","IQ New","TIGGO 2","TIGGO 3","TIGGO 7","TIGGO 8","Skin"],
      JAC :["Refine 2.8", "Refine 1.9"],
      GREATWALL : ["H6","Jolion","M4","Poer","Voleex C30","WINGLE 5","WINGLE 6","WINGLE 7"]
    }
    
    var marcas = document.getElementById("ContactForm-marca");
    var modelos = document.getElementById("ContactForm-modelo");
    var marcasSeleccionada = marcas.value;
    
    // Se limpian los pueblos
    modelos.innerHTML = '<option selected disabled></option>'
    
    if(marcasSeleccionada !== ''){
      marcasSeleccionada = listaModelos[marcasSeleccionada]
      marcasSeleccionada.sort()
    
      // Insertamos los pueblos
      marcasSeleccionada.forEach(function(modelo){
        let opcion = document.createElement('option');
        opcion.value = modelo;
        opcion.text = modelo;
        modelos.add(opcion);
      });

      document.getElementById("ContactForm-label-modelo").style.display = "";
    }   
  }

    function cambioFormularioVin() { 
    document.getElementById("ContactForm-divin").style.display = "";
    document.getElementById("ContactForm-divmodelo").style.display = "none";
    document.getElementById("ContactForm-label-marca").style.display = "";
    $("#ContactForm-marca").val($("#ContactForm-marca option:first").val());
    var modelos = document.getElementById("ContactForm-modelo");
    modelos.innerHTML = '<option selected disabled></option>'
  }

  function cambioFormularioMarca() { 
    document.getElementById("ContactForm-divin").style.display = "none";
    document.getElementById("ContactForm-divmodelo").style.display = "";
    document.getElementById("ContactForm-label-modelo").style.display = "";
    document.getElementById("ContactForm-label-marca").style.display = "";
    $("#ContactForm-marca").val($("#ContactForm-marca option:first").val());
    var modelos = document.getElementById("ContactForm-modelo");
    modelos.innerHTML = '<option selected disabled></option>'
  }

  function estiloModelos() { 
    document.getElementById("ContactForm-label-modelo").style.display = "none"; 
  }

  function sendEmail() { 
    var marca = document.getElementById("ContactForm-marca").value;
    var mail = "";
    
    //if(marca == "HYUNDAI" || marca == "KIA"){
      //mail = "alberto@fitalia.cl,marcelo@fitalia.cl,eduardo.escobar@fitalia.cl,cristian.escobar@fitalia.cl,bruno.solari@fitaliarepuestos.cl"; 
    //}else if (marca == "SSANGYONG"){
      //mail = "bruno.solari@fitaliarepuestos.cl,eduardo.escobar@fitalia.cl,cristian.escobar@fitalia.cl";
    //}else if(marca == "MAHINDRA" || marca == "MAXUS"){
      //mail = "nicolas.alarcon@fitaliarepuestos.cl,albert.castillo@fitaliarepuestos.cl,eduardo.escobar@fitalia.cl,cristian.escobar@fitalia.cl,bruno.solari@fitaliarepuestos.cl";
    //}else if(marca == "MAXUS" || marca == "JMC" || marca == "CHERY" || marca == "MG" || marca == "GREATWALL" || marca == "JAC" || marca == "FOTON" || marca == "CHANGAN" ){
      //mail = "albert.castillo@fitaliarepuestos.cl,eduardo.escobar@fitalia.cl,cristian.escobar@fitalia.cl,bruno.solari@fitaliarepuestos.cl";
    //}else{
    mail = "cristian.escobar@fitalia.cl,bruno.solari@fitalia.cl";
    //}
    
    if(document.getElementById("ContactForm-ano").value == "") {
      alert("debe ingresar año en el formulario");
      return false;
    }

    if(document.getElementById("ContactForm-repuesto").value == "") {
      alert("debe ingresar repuesto en el formulario");
      return false;
    }

    if(document.getElementById("ContactForm-mail").value == "") {
      alert("debe ingresar mail en el formulario");
      return false;
    }
    
    if(document.getElementById("ContactForm-telefono").value == "") {
      alert("debe ingresar telefono en el formulario");
      return false;
    }    

    Email.send({
       SecureToken : "9fc83dd9-47ff-4177-b932-ae264823ef2a",
   // SecureToken :  "e195fb48-af5a-410c-9b50-fee8aa8f04c3",
        To : mail,
        From : "fitalia@gramaweb.cl",
        Subject : "Cotización",
        Body : 
          "<html>"+
                "<table style='height: 100%; width: 100%; background-color: #f5f6f8;' align='center'>" +
                  "<tbody>" + 
                    "<tr>" +
                      "<td class='drow' valign='top' align='center' style='background-color: #ffffff; box-sizing: border-box; font-size: 0px; text-align: center;'>"+ 
                        "<div class='layer_2' style='display: inline-block; vertical-align: top; width: 100%; max-width: 640px;'>" +
                          "<img src='https://cdn.shopify.com/s/files/1/0519/4439/0828/files/LOGO_FITALIA_Mesa_de_trabajo_1_dbf683f5-1991-4395-8a94-517e7733c0ec.png?v=1671203585' alt='Imagen' width='1620' style='border-width: 0px; border-style: none; max-width: 1620px; width: 100%;'>" +
                        "</div>" +
                      "</td>" +
                    "</tr>" +
                    "<tr>" +
                      "<td class='drow' valign='top' align='center' style='background-color: #ffffff; box-sizing: border-box; font-size: 0px; text-align: center;'>"+ 
                        "<div class='layer_2' style='display: inline-block; vertical-align: top; width: 100%; max-width: 640px;'>" +
                          "<p class='style1 text-center' style='line-height: 1.75em; text-align: center; margin: 0px; padding: 0px; color: #000000; font-size: 32px; font-family: &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial, sans-serif;'>Cotización&nbsp;</p>" +
                        "</div>" +
                      "</td>" +
                    "</tr>" +
                    "<tr>" +
                       "<td class='drow' valign='top' align='center' style='background-color: #ffffff; box-sizing: border-box; font-size: 0px; text-align: center;'>" +
                          "<div class='layer_2' style='display: inline-block; vertical-align: top; width: 100%; max-width: 320px;'>" +
                             "<table border='0' cellspacing='0' class='edcontent' style='border-collapse: collapse;width:100%'>" +
                                "<tbody>" +
                                   "<tr>" +
                                      "<td valign='top' class='edtext' style='padding: 32px; text-align: left; color: #5f5f5f; font-size: 15px; font-family: &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial, sans-serif; word-break: break-word; direction: ltr; box-sizing: border-box;'>" +
                                         "<p style='margin: 0px; padding: 0px; font-size: 15px;'>Marca / Año&nbsp;</p>" + document.getElementById("ContactForm-marca").value + " / " + document.getElementById("ContactForm-ano").value +
                                      "</td>" +
                                   "</tr>" +
                                "</tbody>" +
                             "</table>" +
                          "</div>" +
                          "<div class='layer_2' style='display: inline-block; vertical-align: top; width: 100%; max-width: 320px;'>" +
                             "<table border='0' cellspacing='0' class='edcontent' style='border-collapse: collapse;width:100%'>" +
                                "<tbody>" +
                                   "<tr>" +
                                      "<td valign='top' class='edtext' style='padding: 32px; text-align: left; color: #5f5f5f; font-size: 15px; font-family: &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial, sans-serif; word-break: break-word; direction: ltr; box-sizing: border-box;'>" +
                                        "<p style='margin: 0px; padding: 0px; font-size: 15px;'>Modelo </p>" + document.getElementById("ContactForm-modelo").value +
                                      "</td>" +
                                   "</tr>" +
                                "</tbody>" +
                             "</table>" +
                          "</div>" +
                       "</td>" +
                    "</tr>" + 
                    "<tr>" +
                       "<td class='drow' valign='top' align='center' style='background-color: #ffffff; box-sizing: border-box; font-size: 0px; text-align: center;'>" +
                          "<div class='layer_2' style='display: inline-block; vertical-align: top; width: 100%; max-width: 320px;'>" +
                             "<table border='0' cellspacing='0' class='edcontent' style='border-collapse: collapse;width:100%'>" +
                                "<tbody>" +
                                   "<tr>" +
                                      "<td valign='top' class='edtext' style='padding: 32px; text-align: left; color: #5f5f5f; font-size: 15px; font-family: &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial, sans-serif; word-break: break-word; direction: ltr; box-sizing: border-box;'>" +
                                         "<p style='margin: 0px; padding: 0px; font-size: 15px;'>VIN/Matricula&nbsp;</p>" + document.getElementById("ContactForm-vin").value +
                                      "</td>" +
                                   "</tr>" +
                                "</tbody>" +
                             "</table>" +
                          "</div>" +
                          "<div class='layer_2' style='display: inline-block; vertical-align: top; width: 100%; max-width: 320px;'>" +
                             "<table border='0' cellspacing='0' class='edcontent' style='border-collapse: collapse;width:100%'>" +
                                "<tbody>" +
                                   "<tr>" +
                                      "<td valign='top' class='edtext' style='padding: 32px; text-align: left; color: #5f5f5f; font-size: 15px; font-family: &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial, sans-serif; word-break: break-word; direction: ltr; box-sizing: border-box;'>" +
                                        "<p style='margin: 0px; padding: 0px; font-size: 15px;'>Repuestos </p>" + document.getElementById("ContactForm-repuesto").value +
                                      "</td>" +
                                   "</tr>" +
                                "</tbody>" +
                             "</table>" +
                          "</div>" +
                       "</td>" +
                    "</tr>" + 
                    "<tr>" +
                       "<td class='drow' valign='top' align='center' style='background-color: #ffffff; box-sizing: border-box; font-size: 0px; text-align: center;'>" +
                          "<div class='layer_2' style='display: inline-block; vertical-align: top; width: 100%; max-width: 320px;'>" +
                             "<table border='0' cellspacing='0' class='edcontent' style='border-collapse: collapse;width:100%'>" +
                                "<tbody>" +
                                   "<tr>" +
                                      "<td valign='top' class='edtext' style='padding: 32px; text-align: left; color: #5f5f5f; font-size: 15px; font-family: &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial, sans-serif; word-break: break-word; direction: ltr; box-sizing: border-box;'>" +
                                         "<p style='margin: 0px; padding: 0px; font-size: 15px;'>Email Solicitante / Télefono&nbsp;</p>" + document.getElementById("ContactForm-mail").value + " / " + document.getElementById("ContactForm-telefono").value +
                                         "<p style='margin: 0px; padding: 0px; font-size: 15px;'><br></p>" +
                                      "</td>" +
                                   "</tr>" +
                                "</tbody>" +
                             "</table>" +
                          "</div>" +
                       "</td>" +
                    "</tr>" +          
                  "</tbody>" +
                "</table>"+
          "<html>"
    }).then(
      message => window.location.replace("https://www.fitalia.cl/pages/gracias")
      
    );
  }